import * as React from 'react';

import * as styles from './PromoModalActions.css';

export const PromoModalActions: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
